import { render, staticRenderFns } from "./LeavePageStatisticsAll.vue?vue&type=template&id=67c5254d&scoped=true&"
import script from "./LeavePageStatisticsAll.vue?vue&type=script&lang=js&"
export * from "./LeavePageStatisticsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5254d",
  null
  
)

export default component.exports